import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseLocalRepository } from '@data/base/base-local.repository';
import { map, mergeMap, Observable } from 'rxjs';
import { ApiResources } from '@constants/api-resources';
import { ApiSecundariaMapper } from './apiSecundaria.mapper';

@Injectable()
export class ApiSecundariaRepository extends BaseLocalRepository {
  private mapper = new ApiSecundariaMapper();
  constructor(httpClient: HttpClient) {
    super(httpClient, ApiResources.API_SECUNDARIAS);
  }

  getApiSecundaria(): Observable<any> {
    return this.getRequest<any>(ApiResources.API_SECUNDARIAS)
  }
}
